export default __webpack_public_path__ + "static/jennifer-bitmoji-2bd2abd20c7a433757b2a062bec3478b.png";